<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billingpackageserviceused') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <template v-if="currentPackageRows.length">
        <div class="mb-3">
          <SectionHeader :title="$t('apps.billing.message.currentpackage')"/>
          <BaseTable
            :hidePagination="true"
            class="custom-table"
            tableClass="table-bordered"
          >
            <template #thead>
              <thead>
                <tr>
                  <th>{{ $t('apps.billing.label.detail') }}</th>
                  <th>{{ $t('apps.billing.label.expiredat') }}</th>
                </tr>
              </thead>
            </template>
            <template #tbody>
              <tbody>
                <tr
                  v-for="(row, index) in currentPackageRows"
                  :key="index"
                >
                  <td>
                    {{ row.detail }}
                  </td>
                  <td>
                    {{ row.expiredAt }}
                  </td>
                </tr>
              </tbody>
            </template>
          </BaseTable>
        </div>
      </template>
      <template v-if="mapPackages.length">
        <SectionHeader :title="$t('apps.billing.message.selectpackage')"/>
        <div class="row">
          <div
            v-for="(packageItem, index) in mapPackages"
            :key="index"
            class="col-md-12 col-lg-4 mb-3"
          >
            <Package
              :packageKey="packageItem.packageKey"
              :title="packageItem.title"
              :appIcon="packageItem.appIcon"
              :appColor="packageItem.appColor"
              :masterPriceList="packageItem.masterPriceList"
              :apps="packageItem.apps"
              :isFocus="packageItem.isFocus"
              :isShowInfo="false"
              :isShowBackHomeButton="false"
              :advancedTableRows="packageItem.advancedTableRows"
              :addOnTableRows="packageItem.addOnTableRows"
              :channelTableRows="packageItem.channelTableRows"
              :payButtonText="packageItem.payButtonText"
              :payButtonClass="packageItem.payButtonClass"
              @onSubmit="handleSubmit"
            />
          </div>
        </div>
      </template>
    </BaseContent>
  </BaseBody>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import Package from '../../../custom/Package.vue'
import lang from '../../../../lang/index'
import packageMixin from '../../../../mixins/package'

function convertObjectToArray(obj) {
  let result = []

  Object.keys(obj).forEach(key => {
    const parts = key.split('-')
    let appKey = parts[0]
    let moduleKey = parts[1] || null
    let submoduleKey = parts[2] || null

    let appId = parseInt(appKey.replace('appid', ''), 10)
    let moduleId = moduleKey ? parseInt(moduleKey.replace('moduleid', ''), 10) : null
    let submoduleId = submoduleKey ? parseInt(submoduleKey.replace('submoduleid', ''), 10) : null

    let app = result.find(item => item.appId === appId)
    if (!app) {
      app = {
        appId: appId,
        appKey: appKey,
        appName: obj[key],
        modules: [],
      }
      result.push(app)
    }

    if (moduleKey) {
      let module = app.modules.find(m => m.moduleId === moduleId)
      if (!module) {
        module = {
          moduleId: moduleId,
          moduleKey: moduleKey,
          moduleName: obj[key],
          submodules: [],
        }
        app.modules.push(module)
      }

      if (submoduleKey) {
        let submodule = module.submodules.find(s => s.submoduleId === submoduleId)
        if (!submodule) {
          submodule = {
            submoduleId: submoduleId,
            submoduleKey: submoduleKey,
            submoduleName: obj[key],
          }
          module.submodules.push(submodule)
        }
      }
    }
  })

  return result
}

export default {
  components: {
    Package,
  },
  mixins: [packageMixin],
  data () {
    return {
      loading: true,
    }
  },
  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.packages.title'),
      current: {
        app_name: 'packages',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  async mounted () {
    setTimeout(() => {
      this.loading = false
      this.showFinish(this.$Progress)
    }, 1000)
  },
  destroyed () {
    this.leavePage(this.$Progress, [])
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/billingpackage/package/Index.vue